module.exports = __webpack_public_path__ + "static/media/old-woman-thinking.45a94fca.png";